import Icon from "Components/Icon/Icon";

// Íconos de las pantallas de Planes: Material Symbols Rounded y rellenos, como los diseños de Maru
// (Planes Trial, cuenta existente, link de pago) y su regla del 03/11 para la landing: "siempre que
// haya un ícono debe ser filled y rounded". El resto de DrManager sigue con el Icon de siempre.
export default function PlanIcon(props) {
  return <Icon rounded filled {...props} />;
}
